var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card-container',{attrs:{"document":_vm.document,"target":_vm.target,"highlighted":_vm.highlighted}},[_c('card-title',[_c('document-title',{attrs:{"document":_vm.document}})],1),_vm._v(" "),_c('card-row',[_c('span',[_vm._v("\n      "+_vm._s(_vm._f("uppercaseFirstLetter")(_vm.$gettext(_vm.document.area_type, 'area_types')))+"\n    ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }